import styled from 'styled-components';

const BorderBox = styled.div`
  position: relative;
  border: 1px solid #dbd9d6;
  margin-bottom: 2em;
`;

export default BorderBox;
